import { render } from "./SubproductEditComponent.vue?vue&type=template&id=f34c9e56"
import script from "./SubproductEditComponent.vue?vue&type=script&lang=js"
export * from "./SubproductEditComponent.vue?vue&type=script&lang=js"

import "./SubproductEditComponent.vue?vue&type=style&index=0&id=f34c9e56&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__